import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Session} from "../../services/Session";
import {NgxScrollEvent} from 'ngx-scroll-event/dist/ngx-scroll-event';
import {CommonModule} from "@angular/common";
import {v4 as uuid} from 'uuid';
import {NgxScrollEventDirective} from "../../directives/ngx-scroll-event.directive";
import {SafeHtmlPipe} from "../../pipes/SafeHtmlPipe";
import {FormsModule} from "@angular/forms";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {FoundationInit} from "../../directives/foundation.directive";

declare let _: any;
declare let jQuery: any;

@Component({
  selector: 'app-tpiq-paginated-table',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, NgxScrollEventDirective, SafeHtmlPipe, FoundationInit],
  templateUrl: './tpiq-paginated-table.component.html',
  styleUrl: './tpiq-paginated-table.component.scss'
})
export class TpiqPaginatedTableComponent {
  eventNames: Array<string> = [];
  id: string;
  selector: string;
  height: string;
  data: Array<any>;
  columns: Array<any> = [];
  searchString: string;
  showSearchIcon = true;
  showSearch = false;
  companyCurrency: string;

  @Input()
  set setObj(obj: any){
    const base = this;
    setTimeout(() => {
      jQuery(`#${this.id}`).find('*').off();
      base.data = [...obj.rows] || [];
      base.columns = [...obj.columns] || [];
      const options = {...obj.options} || {};
      base.height = options.height || '200px';
      base.selector = options.selectorString || 'id';
      if (options.showSearch != undefined){
        base.showSearch = options.showSearch;
      }
      base.searchString = options.searchString;
      if (base.searchString){
        base.showSearchIcon = false;
      }
      base.renderTable();
    });
  }

  @Output()
  onRowDoubleClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRowClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onDeleteRow: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onAddRow: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onEditRow: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onMouseOver: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onMouseOut: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRowAction: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRowSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onSearch: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onScroll: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRemoveSearch: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onSort: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onExportToFile: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onInputSearchSelection: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onDropdownSelection: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onInputBlur: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onClickIcon: EventEmitter<any> = new EventEmitter<any>();

  constructor(){}

  getSortType(column){
    if (!column.sortType){
      column.sortType = 'asc';
    } else if (column.sortType == 'asc'){
      column.sortType = 'desc';
    } else if (column.sortType == 'desc'){
      column.sortType = 'asc';
    }
    return column.sortType;
  }

  renderTable(){
    const base = this;
    const tableSelector = jQuery(`#${this.id} table`);

    tableSelector.on('click', 'thead th', function(e){
      if (e.target.type != 'checkbox' && jQuery(this).attr('sortable') == 'true'){
        e && e.preventDefault();
        e && e.stopImmediatePropagation();
        const column: any = base.columns[this.cellIndex];
        const obj = {
          column: column.name,
          order: base.getSortType(column),
          searchString: base.searchString
        };
        base.handleOnSort(obj);
      }
    });

    tableSelector.on('click', 'tbody tr', function(e){
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj){
        return obj[base.selector] == id;
      });
      if (row){
        if (row.hasOwnProperty('isEditable')) {
          row.isEditable = true;
          base.resetAll(row);
        }
        base.handleOnClick(row);
      }
    });

    tableSelector.on('dblclick', 'tbody tr', function(e){
      e.preventDefault();
      e.stopPropagation();
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj){
        return obj[base.selector] == id;
      });
      base.handleOnDoubleClick(row);
    });


    tableSelector.on('click', 'tbody tr a', function(e){
      e.preventDefault();
      e.stopPropagation();
      const action = jQuery(this).data('action');
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj){
        return obj[base.selector] == id;
      });
      row.action = action;
      if (action == 'delete') {
        base.handleOnAction(row);
      } else if (action == 'verify'){
        jQuery(this).hide();
      } else {
        base.handleOnAction(row);
      }
    });

    tableSelector.on('change', 'tbody tr input.checkbox', function(e) {
      e.stopImmediatePropagation();
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj){
        return obj[base.selector] == id;
      });
      base.handleOnSelect(row);
    });

    tableSelector.on('click', 'thead tr input.global-checkbox', function(e) {
      if (jQuery(this).is(':checked')) {
        base.handleOnSelect(true);
      } else{
        base.handleOnSelect(false);
      }
    });

    tableSelector.on('click', 'tbody tr input.radio', function(e) {
      let selectedRows = [];
      jQuery(`#${this.id} table`).find('tbody tr input.radio').each(function(idx, cbox){
        const id = jQuery(this).closest('tr').attr('id');
        const row = _.find(base.data, function(obj){
          return obj[base.selector] == id;
        });
        if (jQuery(cbox).is(':checked')) {
          selectedRows = [...selectedRows, row];
        }
      });
      base.handleOnSelect(selectedRows);
    });
  }

  ngOnInit(){
    this.id = uuid();
    this.companyCurrency = Session.getCurrentCompanyCurrency();
  }

  handleScroll($event: NgxScrollEvent){
    this.onScroll.next($event);
  }

  handleOnClick(obj) {
    this.onRowClick.next(obj);
  }

  handleOnAction(obj) {
    this.onRowAction.next(obj);
  }

  handleOnSelect(obj) {
    this.onRowSelect.next(obj);
  }

  handleMouseOver(obj) {
    this.onMouseOver.next(obj);
  }

  handleMouseOut() {
    this.onMouseOut.next({});
  }

  handleAddRow() {
    this.onAddRow.next({});
  }

  handleDeleteRow(obj) {
    this.onDeleteRow.next(obj);
  }

  handleEditRow(obj) {
    this.onEditRow.next(obj);
  }

  handleOnDoubleClick(obj) {
    this.onRowDoubleClick.next(obj);
  }

  handleOnSearch(obj){
    this.onSearch.next(obj);
  }

  handleOnSort(obj){
    this.onSort.next(obj);
  }

  doSearch($event){
    if ($event.keyCode == 13){
      $event && $event.preventDefault();
      this.handleOnSearch(this.searchString);
    }
  }

  exportToFile(fileType){
    this.onExportToFile.next(fileType);
  }

  removeSearch($event){
    this.searchString = '';
    this.showSearchIcon = true;
    this.onRemoveSearch.next({});
  }

  ngOnDestroy() {
    jQuery(`#${this.id}`).find('*').off();
  }

  propagateSelection($event){
    this.onInputSearchSelection.next($event);
  }

  propagateDropdownSelection($event){
    this.onDropdownSelection.next($event);
  }

  resetAll(selectedRow) {
    const base = this;
    selectedRow.isEditable = true;
    _.each(this.data, function(obj){
      if (obj[base.selector] !== selectedRow[base.selector]){
        obj.isEditable = false;
      } else{
        obj.isEditable = true;
      }
    });
  }

  getDropdownData(data, current) {
    let updated = [];
    if (current === 'Not Done'){
      updated = data;
    } else {
      const obj = _.find(data, {key: current});
      for (const i in data) {
        if (data[i].order >= obj.order) {
          updated = [...updated, data[i]];
        }
      }
    }
    return updated;
  }

  getSubStatusChange(column, current, obj) {
    let updated = [];
    if (current === 'Not Done'){
      updated = column.data;
    } else {
      const statuses = column[obj.status];
      for (const i in statuses) {
        const statusObj = {};
        statuses[i].key = statuses[i].id;
        statuses[i].value = statuses[i].status;
        updated = [...statuses[i]];
      }
    }
    return updated;
  }

  getTypeStatusChange(column, current, obj) {
    let updated = [];
    const statuses = column[obj.type] ? column[obj.type].typeStatus : [];
    for (const i in statuses) {
      const statusObj = {};
      statuses[i].key = statuses[i].id;
      statuses[i].value = statuses[i].status;
      updated = [...statuses[i]];
    }
    return updated;
  }

  onInputChange(obj, col) {
    this.onInputBlur.next({
      row: obj,
      column: col
    });
  }

  updateWithClickIcon(obj, col) {
    this.onClickIcon.next({
      row: obj,
      column: col.name
    });
  }

}
